<template>
    <div class="countdown flex -m-1 justify-center">
        <div class="countdown-container days m-1 relative">
            <span class="countdown-value block text-xl text-white font-semibold text-center rounded py-1 px-3 relative bg-[rgba(36,36,53,0.3)] backdrop-blur-[15px] after:content-[':'] after:absolute after:top-1/2 after:-right-2 after:transform after:-translate-y-1/2 after:text-base after:text-gray-400 after:font-normal">{{ twoDigits(days) }}</span>
            <span class="countdown-heading block text-sm text-gray-400 text-center uppercase mt-0">D's</span>
        </div>
        <div class="countdown-container hours m-1 relative">
            <span class="countdown-value block text-xl text-white font-semibold text-center rounded py-1 px-3 relative bg-[rgba(36,36,53,0.3)] backdrop-blur-[15px] after:content-[':'] after:absolute after:top-1/2 after:-right-2 after:transform after:-translate-y-1/2 after:text-base after:text-gray-400 after:font-normal">{{ twoDigits(hours) }}</span>
            <span class="countdown-heading block text-sm text-gray-400 text-center uppercase mt-0">H's</span>
        </div>
        <div class="countdown-container minutes m-1 relative">
            <span class="countdown-value block text-xl text-white font-semibold text-center rounded py-1 px-3 relative bg-[rgba(36,36,53,0.3)] backdrop-blur-[15px] after:content-[':'] after:absolute after:top-1/2 after:-right-2 after:transform after:-translate-y-1/2 after:text-base after:text-gray-400 after:font-normal">{{ twoDigits(minutes) }}</span>
            <span class="countdown-heading block text-sm text-gray-400 text-center uppercase mt-0">Min's</span>
        </div>
        <div class="countdown-container seconds m-1 relative">
            <span class="countdown-value block text-xl text-white font-semibold text-center rounded py-1 px-3 relative bg-[rgba(36,36,53,0.3)] backdrop-blur-[15px]">{{ twoDigits(seconds) }}</span>
            <span class="countdown-heading block text-sm text-gray-400 text-center uppercase mt-0">Sec</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Countdown',
        props: {
            date: null
        },
        data() {
            return {
                now: Math.trunc((new Date()).getTime() / 1000),
                event: new Date(`${this.date}T16:37:00`),
                finish: false
            }
        },
        computed: {
            secondCount () {
                return this.calculatedDate - this.now
            },
            calculatedDate () {
                return Math.trunc(Date.parse(this.event) / 1000)
            },
            seconds () {
                if (this.secondCount < 0) return 0
                return this.secondCount % 60
            },
            minutes () {
                if (this.secondCount < 0) return 0
                return Math.trunc(this.secondCount / 60) % 60
            },
            hours () {
                if (this.secondCount < 0) return 0
                return Math.trunc(this.secondCount / 60 / 60) % 24
            },
            days () {
                if (this.secondCount < 0) return 0
                return Math.trunc(this.secondCount / 60 / 60 / 24)
            }
        },
        methods: {
            twoDigits (value) {
                if (value.toString().length <= 1) {
                    return '0' + value.toString();
                }
                return value.toString();
            }
        },
        mounted () {
            const _self = this;
            window.setInterval(() => {
                this.now = Math.trunc((new Date()).getTime() / 1000)
                if (!this.finish && this.calculatedDate - this.now <= 0) {
                    _self.finish = true
                    _self.$emit('onFinish')
                }
            }, 1000);
        },
    }
</script>